import { render, staticRenderFns } from "./shareConfirm.vue?vue&type=template&id=0f656554&scoped=true"
import script from "./shareConfirm.vue?vue&type=script&lang=js"
export * from "./shareConfirm.vue?vue&type=script&lang=js"
import style0 from "./shareConfirm.vue?vue&type=style&index=0&id=0f656554&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f656554",
  null
  
)

export default component.exports